/**
 * Arabic for the dispatch bar on the maps — the teams by kind, and whether the
 * aircraft movement area is clear. Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  "{n} not signed in to the mobile app": "{n} غير مسجّلين في تطبيق الجوال",
  DISPATCH: "بلاغ",
  "Not raised in the register: {why}": "لم يُفتح في سجل أوامر العمل: {why}",
  "SMS and email wait in the outbox until a provider is set up.":
    "تنتظر الرسائل النصية والبريد في صندوق الصادر حتى يُضبط مزوّد الخدمة.",
  "canceled by the aerodrome officer": "ألغاه ضابط المطار",
  "canceled in the register": "أُلغي في السجل",
  "closed by the aerodrome officer": "أغلقه ضابط المطار",
  "closed in the register": "أُغلق في السجل",
  "the team": "الفريق",
  "the team, from the mobile app": "الفريق، من تطبيق الجوال",
  "the work order register": "سجل أوامر العمل",
  "{n} canceled in the register; the team is told it is called off.":
    "أُلغي {n} في السجل؛ وأُبلغ الفريق بإلغاء المهمة.",
  "{n} closed in the register.": "أُغلق {n} في السجل.",
  "{n} was canceled in the register; the team is released.": "أُلغي {n} في السجل؛ وأُطلق الفريق.",
  "{n} was closed by {who} — the team is released and returns to the staging area.":
    "أغلق {who} البلاغ {n} — أُطلق الفريق ويعود إلى منطقة التجمّع.",
  "{n}: the register did not take it — {why}": "{n}: لم يقبله السجل — {why}",
  "ADD A PERSON": "إضافة شخص",
  CONTACTS: "جهات الاتصال",
  "Nobody on file to tell — add the team's people.": "لا أحد مسجّل لإبلاغه — أضف أفراد الفريق.",
  SAVE: "حفظ",
  "Saved — the next dispatch reaches these people.": "حُفظ — سيصل البلاغ التالي إلى هؤلاء.",
  "Told on dispatch: {people}": "يُبلَّغ عند الإرسال: {people}",
  app: "التطبيق",
  "mobile, 05…": "الجوال، 05…",
  "{number} sent to {team} — {people} people: {sms} SMS, {email} email, {app} app alerts":
    "أُرسل {number} إلى {team} — {people} أشخاص: {sms} رسالة نصية، {email} بريد، {app} تنبيه في التطبيق",
  "{n} could not be reached (no contact on file)": "تعذّر الوصول إلى {n} (لا توجد وسيلة اتصال مسجّلة)",
  "CLOSE THE SURFACE": "أغلق السطح",
  CLOSURES: "الإغلاقات",
  "Closed by NOTAM. A closure in force puts an X on every entrance and exit of the surface, from both directions.":
    "مغلق بموجب نوتام. يضع الإغلاق النافذ علامة X على كل مدخل ومخرج للسطح، من الاتجاهين.",
  "LIFT — REOPEN": "رفع الإغلاق — إعادة الفتح",
  "NOTAM number": "رقم النوتام",
  "NOTAM number, e.g. A0431/26": "رقم النوتام، مثل A0431/26",
  "Record a closure": "تسجيل إغلاق",
  "Runway and taxiway closures": "إغلاقات المدارج وممرات الطائرات",
  Taxiway: "ممر الطائرات",
  "The NOTAM number is what makes it a closure — enter it.": "رقم النوتام هو ما يجعله إغلاقاً — أدخله.",
  Which: "أيّ",
  from: "من",
  "lifted by {who}": "رفعه {who}",
  "why — scheduled maintenance, works, …": "السبب — صيانة مجدولة، أعمال، …",
  "{surface} closed under {notam}.": "أُغلق {surface} بموجب {notam}.",
  "IN FORCE": "نافذ",
  SCHEDULED: "مجدول",
  ENDED: "منتهٍ",
  LIFTED: "مرفوع",
  "AGL teams": "فرق الإنارة الأرضية",
  "Civil Defence": "الدفاع المدني",
  "Safety officers": "مسؤولو السلامة",
  "{n} out": "{n} في مهمة",
  "Pick a target on the map first": "اختر هدفاً على الخريطة أولاً",
  "MOVEMENT AREA CLEAR": "منطقة الحركة خالية",
  "MOVEMENT AREA NOT CLEAR": "منطقة الحركة غير خالية",
  "{n} ON THE MOVEMENT AREA": "{n} على منطقة الحركة",
  "working on {wo}": "يعمل على {wo}",
  inspecting: "يُجري فحصاً",
  vacating: "يُخلي المنطقة",
  "no job — must leave": "بلا مهمة — يجب أن يغادر",
  "Released or recalled, every team and piece of equipment leaves the runways and taxiways at once and stays clear.":
    "عند إنهاء المهمة أو الاستدعاء، يغادر كل فريق وكل معدة المدارج وممرات الطائرات فوراً ويبقى بعيداً عنها.",
};

export default ar;
